<div class="row">
  <div class="col s12 m4">
    <h4 class="card-title">Data Viewer</h4>
  </div>
  <div class="col s12 m4">
    <a routerLink="/data-patch">Data Patch</a>
  </div>
  <div class="col s12 m8 right-align">
    <a (click)="dataExportCsv()" *ngIf="!isLoading" class="waves-effect waves-light grey lighten-1 btn mb-1" style="min-width: 158px;">
      <i class="material-icons right">format_list_bulleted</i> Export CSV
    </a>
    <div *ngIf="isLoading">
      <div class="preloader-wrapper small active">
        <div class="spinner-layer spinner-blue-only">
          <div class="circle-clipper left">
            <div class="circle"></div>
          </div><div class="gap-patch">
            <div class="circle"></div>
          </div><div class="circle-clipper right">
            <div class="circle"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="row">
  <div class="col s12 m6">
    <span [hidden]="isLoading">
      <!-- <input [owlDateTime]="dt1" [owlDateTimeTrigger]="dt1" placeholder="DATE">
      <owl-date-time #dt1></owl-date-time> -->
      <input (dateTimeChange)="dateChange()" [(ngModel)]="selectedMoment" [owlDateTime]="dt1" style="width: 90px;">
      <span class="trigger" [owlDateTimeTrigger]="dt1">
        <i class="material-icons tatt-i-btn">date_range</i>
      </span>
      <owl-date-time [pickerType]="'calendar'" #dt1></owl-date-time>
    </span>
  </div>
  <div class="col s12 m6 right-align">
    <a class='dropdown-trigger btn waves-effect waves-light btn gradient-45deg-green-teal z-depth-4 mb-2' href='#' data-target='ddl_dashboard_areas' style="min-width:158px; margin-top: 3px;">
      <i class="material-icons right" style="opacity:0.7;">keyboard_arrow_down</i>
      <span *ngIf="!area">Loading..</span>
      <span *ngIf="area">{{area.areaName}}</span>
    </a>
    <!-- Dropdown Structure -->
    <ul id='ddl_dashboard_areas' class='dropdown-content'>
      <!-- <li><a (click)="areaSelect(-1)" class="li_area">-- ALL --</a></li> -->
      <!-- <li class="divider" tabindex="-1"></li> -->
      <li (click)="areaSelect(rec)" *ngFor="let rec of pageData.areas; let iRec = index;">
        <a href="javascript:void(0);" class="li_area">{{rec.areaName}}</a>
      </li>
    </ul>
    <i (click)="pageData.autoRefresh = !pageData.autoRefresh" class="material-icons tatt-i-btn hide" [ngClass]="{'icon-light-blue': pageData.autoRefresh}">refresh</i>
  </div>
</div>
<div>
<div class="row">
  <div class="col s12 m4 l4 hide">
    <div class="card padding-4 animate fadeLeft">
      <div class="row">
        <div class="col s5 m5">
          <h5 class="mb-0">{{pageData.inValue}}</h5>
          <p class="no-margin">Entry Total</p>
        </div>
        <div class="col s7 m7 right-align">
          <i class="material-icons background-round mt-5 mb-5 gradient-shadow gradient-45deg-light-blue-cyan white-text">people</i>
        </div>
      </div>
      <div class="row mt-5">
        <div class="col s5 m5">
          <p class="mb-0">Last Week</p>
          <p class="mb-0">1220</p>
        </div>
        <div class="col s7 m7 right-align">
          <p class="mb-0"></p>
        </div>
      </div>
    </div>
  </div>
  <div class="col s12 m4 14 hide">
    <div class="card padding-4 animate fadeLeft">
      <div class="row">
        <div class="col s5 m5">
          <h5 class="mb-0">{{pageData.outValue}}</h5>
          <p class="no-margin">Exit Total</p>
        </div>
        <div class="col s7 m7 right-align">
          <i class="material-icons background-round mt-5 mb-5 gradient-45deg-purple-deep-orange gradient-shadow white-text">people_outline</i>
        </div>
      </div>
      <div class="row mt-5">
        <div class="col s5 m5">
          <p class="mb-0">Last Week</p>
          <p class="mb-0">1108</p>
        </div>
        <div class="col s7 m7 right-align">
          <p class="mb-0"></p>
        </div>
      </div>
    </div>
  </div>
  <div class="col s12 m4 14 hide">
    <div class="card padding-4 animate fadeLeft">
      <div class="row">
        <div class="col s5 m5">
          <h5 class="mb-0">{{pageData.occupancyValue}}</h5>
          <p class="no-margin">Occupancy</p>
        </div>
        <div class="col s7 m7 right-align">
          <i class="material-icons background-round mt-5 mb-5 gradient-45deg-deep-orange-orange gradient-shadow white-text">people_outline</i>
        </div>
      </div>
      <div class="row mt-5">
        <div class="col s5 m5">
          <p class="mb-0">Last Week</p>
          <p class="mb-0">45</p>
        </div>
        <div class="col s7 m7 right-align">
          <p class="mb-0"></p>
        </div>
      </div>
    </div>
  </div>
  <div class="col s12 m12 l12" *ngIf="area && area.sensors && area.sensors.length>0">
    <table style="width:100%;">
      <tr>
        <td></td>
        <ng-container *ngFor="let rec of area.intervals">
          <td colspan="2" style="text-align: center;">{{rec.time}}</td>
        </ng-container>
      </tr>
      <tr>
        <td style="font-size: 12px;">{{area.areaName}}</td>
        <ng-container *ngFor="let d of area.sData">
          <td style="text-align: center;" class="f-num-s">
            {{d.inValue==0? '-': d.inValue}}
          </td>
          <td style="border-right: 1px solid #d3d3d3;text-align: center;" class="f-num-s">
            {{d.outValue==0? '-': d.outValue}}
          </td>
        </ng-container>
      </tr>
      <tr>
        <td style="font-size: 12px;">{{pageData.inValue}} | {{pageData.outValue}}</td>
        <ng-container *ngFor="let d of area.oData">
          <td style="border-right: 1px solid #d3d3d3; text-align: center;" class="f-num" colspan="2">
            {{d.inValue==0? '-': d.inValue}}
          </td>
        </ng-container>
      </tr>
      <tr *ngFor="let s of area.sensors">
        <td style="font-size: 12px; opacity: 0.6;">
          <ng-container *ngIf="area.areaId != '0'">
            <div *ngIf="s.inFlow==1" class="s-c-in">&nbsp;</div>
            <div *ngIf="s.inFlow==2" class="s-c-out">&nbsp;</div>
            <div *ngIf="s.inFlow==0" class="s-c-na">&nbsp;</div>
            <div *ngIf="s.outFlow==1" class="s-c-in">&nbsp;</div>
            <div *ngIf="s.outFlow==2" class="s-c-out">&nbsp;</div>
            <div *ngIf="s.outFlow==0" class="s-c-na">&nbsp;</div>
          </ng-container>
          &nbsp;{{s.sensorId}}
          <div>{{s.inValue}}|{{s.outValue}}</div>
        </td>
        <ng-container *ngIf="s.data">
          <ng-container *ngFor="let d of s.sData">
            <td style="text-align: center;" class="f-num">
              {{d.inValue==0? '-': d.inValue}}
            </td>
            <td style="border-right: 1px solid #d3d3d3;text-align: center;" class="f-num">
              {{d.outValue==0? '-': d.outValue}}
            </td>
            <!-- <div style="font-size:9px; background-color:#efefef; border:1px solid #d3d3d3; border-radius: 8px; padding:2px; float:left; margin-right: 3px;">{{d.timestamp | date:'HH'}} hr</div>
            {{d.inValue}} | {{d.outValue}} -->
          </ng-container>
        </ng-container>
      </tr>
    </table>
  </div>
</div>
<div class="row">
  <div class="col s12 m12 14 hide">
    <div class="card animate fadeleft">
      <div class="card-content">
        <h4 class="card-title mb-0">Hourly Entry</h4>
        <div class="pnl-chart-line-01">
          <div class="chart-line-01 chartLineIn"></div>
        </div>
      </div>
    </div>
  </div>
  <div class="col s12 m12 14 hide">
    <div class="card animate fadeleft">
      <div class="card-content">
        <h4 class="card-title mb-0">Hourly Exit</h4>
        <div class="pnl-chart-line-01">
          <div class="chart-line-01 chartLineOut"></div>
        </div>
      </div>
    </div>
  </div>
  <div class="col s12 m12 14 hide">
    <div class="card animate fadeleft">
      <div class="card-content">
        <h4 class="card-title mb-0">Hourly Occupancy</h4>
        <div class="pnl-chart-line-01">
          <div class="chart-line-01 chartLineOcc"></div>
        </div>
      </div>
    </div>
  </div>
</div>